import { useState, useEffect, useMemo } from 'react';
import { collection, query, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { authService } from '../../../services/authService';
import { resolverStelorderId } from './estadosObra';

// Carga las obras (Firebase, en vivo) y calcula el estado de puesta en
// marcha de todos sus clientes en un único lote — reutilizado tanto por la
// pestaña Obras como por la pestaña Analítica compartida (Contratos/
// Captación/Socios/Comunidades/Obras/Analítica), para no duplicar la lógica.
export default function useObrasConEstado() {
  const [obras, setObras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [estadosCalculados, setEstadosCalculados] = useState({});

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, 'obras'), limit(2000)),
      (snap) => {
        setObras(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(o => o.activo !== false));
        setLoading(false);
      },
      (err) => { console.error('[onSnapshot obras]', err); setLoading(false); }
    );
    return () => unsub();
  }, []);

  const todosLosStelorderIds = useMemo(() => {
    const ids = new Set();
    for (const obra of obras) for (const c of obra.clientes || []) {
      const sid = resolverStelorderId(c);
      if (sid) ids.add(sid);
    }
    return [...ids];
  }, [obras]);

  useEffect(() => {
    if (todosLosStelorderIds.length === 0) { setEstadosCalculados({}); return; }
    let cancelado = false;
    fetch('/.netlify/functions/estadoClientesObra', {
      method: 'POST', headers: { 'Content-Type': 'application/json', ...authService.authHeader() },
      body: JSON.stringify({ stelorderIds: todosLosStelorderIds }),
    })
      .then(r => r.json())
      .then(d => { if (!cancelado && d.success) setEstadosCalculados(d.estados); })
      .catch(() => {});
    return () => { cancelado = true; };
  }, [todosLosStelorderIds]);

  const estadoDe = (c) => {
    const sid = resolverStelorderId(c);
    return (sid && estadosCalculados[String(sid)]) || 'registrado';
  };

  return { obras, loading, estadoDe };
}
